<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <el-input v-model="ajaxSearch.login" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_badge')}}</template>
                            <b-form-select v-model="ajaxSearch.badge_name">
                                <option value="">-</option>
                                <option v-for="(list,index) in ajaxToolList.badgeList" :key="index" :value='list.name'>{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" size="lg" class="float-right mb-3" v-b-modal.addBadge v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('badge_list.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="primary" size="lg" @click="getTopupBonus()" v-if="permissionList.includes(permission.bonus)"><font-awesome-icon icon="plus"/> {{$t('badge_list.table_topup_bonus')}}</b-button>
                            <b-button variant="info" size="lg" class="ml-1" @click="infoBadge()" v-if="permissionList.includes(permission.info)">{{$t('badge_list.table_info')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteBadge()" v-if="permissionList.includes(permission.delete)">{{$t('badge_list.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>      

                <b-modal id="infoBadge" :title="$t('badge_list.table_check_badge')" hide-footer size="lg">
                    <b-row class="form-label">
                        <b-col cols="6">
                            <b-form-group label-cols="12" label-cols-lg="5">
                                <template slot="label">{{$t('admin.table_id')}}</template>
                                <label>{{ajaxInfo.id}}</label>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="5">
                                <template slot="label">{{$t('admin.table_username')}}</template>
                                <label>{{ajaxInfo.login}}</label>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="5">
                                <template slot="label">{{$t('admin.table_badge')}}</template>
                                <label>{{ajaxInfo.badge_name}}</label>                                                        
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-cols="12" label-cols-lg="5">
                                <template slot="label">{{$t('admin.table_available_freeze_amount')}}</template>
                                <label>{{ajaxInfo.available_freeze_amount}}</label>                                                        
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="5">
                                <template slot="label">{{$t('admin.table_created_at')}}</template>
                                <label>{{ajaxInfo.created_at}}</label>                                                        
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-modal>   

                <b-modal id="addBadge" :title="$t('badge_list.table_add')" hide-footer>
                    <form id="addBadgeForm" @submit.prevent="addBadge">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <b-form-input name="login"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_amount')}}</template>
                            <b-form-input name="total_amount"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_badge')}}</template>
                            <b-form-select name="code">
                                <option v-for="(list,index) in badgeList" :key="index" :value='list.code'>{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-button variant="primary" @click="addBadge()" class="float-right">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>

                <b-modal id="bonusTopup" :title="$t('badge_list.table_topup_bonus')" hide-footer>
                    <form id="bonusTopupForm" @submit.prevent="bonusTopup">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <label>{{ajaxLogin}}</label>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('badge_list.table_topup_bonus')}}</template>
                            <b-form-select name="code">
                                <option v-for="(list,index) in ajaxBonusTopup" :key="index" :value="list.code">{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_amount')}}</template>
                            <b-form-input name="total_amount"></b-form-input>
                        </b-form-group>
                        <b-button variant="primary" @click="bonusTopup()" class="float-right">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,badgeAjaxTable,badgeInfo,badgeAdd,badgeDelete,getBonusTopup,bonusTopup} from '@/system/model/badge'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',login:'',badge_name:'',created_at:''},
            ajaxAdd:{sort:10,status:1,languageList:[]},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            ajaxLogin:'',
            ajaxMasterId:'',
            ajaxInfo:[],
            ajaxBonusTopup:[],
            ajaxToolList:[],
            badgeList:[],
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'BA8B1C',
                bonus:'00212C',
                info:'19FC44',
                delete:'832DB4'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '5'
            },{
                prop: "login",
                label: this.$t('admin.table_username'),
                width: '10'
            },{
                prop: "badge_name",
                label: this.$t('admin.table_badge'),
                width: '10'
            },{
                prop: "created_at",
                label: this.$t('admin.table_created_at'),
                width: '10'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = badgeAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.login,this.ajaxSearch.badge_name,this.ajaxSearch.created_at);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.badgeList = value.data.badge_list;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },infoBadge(){
            if(this.permissionList.includes(this.permission.info)){
                var self = this;
                var result = badgeInfo(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('infoBadge');
                        self.ajaxInfo = value.data;
                    }
                })
            }
        },addBadge(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                self.preloader(true);
                var form = document.getElementById('addBadgeForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = badgeAdd(formData);		
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();         
                                self.$bvModal.hide('addBadge');   
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                                self.$bvModal.hide('addBadge');
                            }
                        });
                    }
                });
            }
        },getTopupBonus(){
            var self = this;
            var result = getBonusTopup(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$bvModal.show('bonusTopup');
                    self.ajaxBonusTopup = value.data.bonus_list;
                }
            })
        },bonusTopup(){
            if(this.permissionList.includes(this.permission.bonus)){
                var self = this;
                self.preloader(true);
                var form = document.getElementById('bonusTopupForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('master_id', this.ajaxMasterId); 
                var result = bonusTopup(formData);		
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();         
                                self.$bvModal.hide('bonusTopup');   
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                                self.$bvModal.hide('bonusTopup');
                            }
                        });
                    }
                });
            }
        },deleteBadge(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = badgeDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            this.ajaxLogin = row.login;
            this.ajaxMasterId = row.master_id;
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift();
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
